import axios from 'axios';

axios.defaults.headers = {
    'Authorization': 'Bearer ' + localStorage.getItem('token'),
    'Accept': 'application/json',
};

import i18n from '../../i18n';

// Default payment types fallback when API returns empty or fails
const DEFAULT_PAYMENT_TYPES = [
    { value: 'CASH', label: i18n.t('pluginPaymentMappings.cash_short') },
    { value: 'CASHLESS', label: i18n.t('pluginPaymentMappings.cashless_short') }
];

const PAYMENT_TYPE_LABELS = {
    CASH: i18n.t('pluginPaymentMappings.cash_short'),
    CASHLESS: i18n.t('pluginPaymentMappings.cashless_short')
};

const state = {
    receipts: [],
    cashiers: [],
    cashier: null,
    cashiersForSelect: {},
    paymentMappings: [],
    checkboxPaymentTypes: [],
    crmPaymentMethods: [],
    paymentOptions: [],
    fiscalizationTriggers: [],
    triggerStatuses: [],
};

const getters = {
    receipts: state => state.receipts,
    cashiers: state => state.cashiers,
    cashier: state => state.cashier,
    cashiersForSelect: state => state.cashiersForSelect,
    paymentMappings: state => state.paymentMappings,
    checkboxPaymentTypes: state => state.checkboxPaymentTypes,
    crmPaymentMethods: state => state.crmPaymentMethods,
    paymentOptions: state => state.paymentOptions,
    fiscalizationTriggers: state => state.fiscalizationTriggers,
    triggerStatuses: state => state.triggerStatuses,
};

const actions = {
    // Receipts
    getReceiptsByOrder: async ({ commit }, orderId) => {
        try {
            const result = await axios.get(`/checkbox/receipts/order/${orderId}`);
            commit('changeReceipts', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    createManualReceipt: async (ctx, payload) => {
        try {
            const result = await axios.post('/checkbox/receipts/manual', payload);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    resolveCashier: async (ctx, orderId) => {
        try {
            const result = await axios.get(`/checkbox/receipts/resolve-cashier/${orderId}`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    getOrderSettings: async (ctx, orderId) => {
        try {
            const result = await axios.get(`/checkbox/orders/${orderId}/settings`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    updateOrderSettings: async (ctx, { orderId, data }) => {
        try {
            const result = await axios.put(`/checkbox/orders/${orderId}/settings`, data);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    // Cashiers
    getCashiers: async ({ commit }) => {
        try {
            const result = await axios.get('/checkbox/cashiers');
            commit('changeCashiers', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    getCashier: async ({ commit }, id) => {
        try {
            const result = await axios.get(`/checkbox/cashiers/${id}`);
            commit('changeCashier', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    getCashiersForSelect: async ({ commit }) => {
        try {
            const result = await axios.get('/checkbox/cashiers/for_select');
            commit('changeCashiersForSelect', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    createCashier: async (ctx, payload) => {
        try {
            const result = await axios.post('/checkbox/cashiers', payload);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    updateCashier: async (ctx, { id, data }) => {
        try {
            const result = await axios.put(`/checkbox/cashiers/${id}`, data);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    deleteCashier: async (ctx, id) => {
        try {
            const result = await axios.delete(`/checkbox/cashiers/${id}`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    testCashier: async (ctx, id) => {
        try {
            const result = await axios.get(`/checkbox/cashiers/${id}/test`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    // Cashier Shift Management
    getShiftStatus: async (ctx, id) => {
        try {
            const result = await axios.get(`/checkbox/cashiers/${id}/shift`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    openShift: async (ctx, id) => {
        try {
            const result = await axios.post(`/checkbox/cashiers/${id}/shift`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    closeShift: async (ctx, id) => {
        try {
            const result = await axios.post(`/checkbox/cashiers/${id}/shift/close`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    // Counterparties for Cashier (new API for multiselect)
    getAvailableCounterparties: async (ctx, cashierId) => {
        try {
            const result = await axios.get(`/checkbox/cashiers/${cashierId}/counterparties/available`);
            return {
                status: true,
                data: result.data.models || result.data.data || result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    syncCounterparties: async (ctx, { cashierId, counterpartyIds }) => {
        try {
            const result = await axios.post(`/checkbox/cashiers/${cashierId}/counterparties/sync`, {
                counterparty_ids: counterpartyIds
            });
            return {
                status: true,
                data: result.data.data || result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    // Check if receipt can be created for order
    canCreateReceipt: async (ctx, orderId) => {
        try {
            const result = await axios.get(`/checkbox/receipts/can-create/${orderId}`);
            return {
                status: true,
                data: result.data.data || result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    getCashierPaymentTypes: async (ctx, id) => {
        try {
            const result = await axios.get(`/checkbox/cashiers/${id}/payment-types`);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    // Payment Mappings
    getPaymentMappings: async ({ commit }) => {
        try {
            const result = await axios.get('/checkbox/payment-mappings');
            commit('changePaymentMappings', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    getCheckboxPaymentTypes: async ({ commit }) => {
        try {
            const result = await axios.get('/checkbox/payment-mappings/checkbox-types');
            const types = result.data.models;
            // Use default types if API returns empty
            if (!types || types.length === 0) {
                commit('changeCheckboxPaymentTypes', DEFAULT_PAYMENT_TYPES);
                return {
                    status: true,
                    data: DEFAULT_PAYMENT_TYPES
                };
            }
            // Normalize API response format: ['CASH', ...] or { type, name } -> { value, label }
            const normalizedTypes = types.map(t => {
                if (typeof t === 'string') {
                    return {
                        value: t,
                        label: PAYMENT_TYPE_LABELS[t] || t
                    };
                }
                const value = t.type || t.value;
                return {
                    value,
                    label: t.name || t.label || PAYMENT_TYPE_LABELS[value] || value
                };
            });
            commit('changeCheckboxPaymentTypes', normalizedTypes);
            return {
                status: true,
                data: normalizedTypes
            };
        } catch (e) {
            // Use default types on error
            commit('changeCheckboxPaymentTypes', DEFAULT_PAYMENT_TYPES);
            return {
                status: false,
                data: DEFAULT_PAYMENT_TYPES
            };
        }
    },

    getCrmPaymentMethods: async ({ commit }) => {
        try {
            const result = await axios.get('/checkbox/payment-mappings/crm-methods');
            commit('changeCrmPaymentMethods', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    getPaymentOptions: async ({ commit }) => {
        try {
            const result = await axios.get('/checkbox/payment-options');
            const rawOptions = result.data.models || [];
            const list = Array.isArray(rawOptions) ? rawOptions : Object.values(rawOptions);
            const normalizedOptions = list.map(option => ({
                ...option,
                type: option.type ? option.type.toUpperCase() : option.type
            }));
            commit('changePaymentOptions', normalizedOptions);
            return {
                status: true,
                data: normalizedOptions
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    createPaymentMapping: async (ctx, payload) => {
        try {
            const result = await axios.post('/checkbox/payment-mappings', payload);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    updatePaymentMapping: async (ctx, { id, data }) => {
        try {
            const result = await axios.put(`/checkbox/payment-mappings/${id}`, data);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    deletePaymentMapping: async (ctx, id) => {
        try {
            const result = await axios.delete(`/checkbox/payment-mappings/${id}`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    // Fiscalization Triggers
    getFiscalizationTriggers: async ({ commit }) => {
        try {
            const result = await axios.get('/checkbox/fiscalization-triggers');
            commit('changeFiscalizationTriggers', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    getTriggerStatuses: async ({ commit }) => {
        try {
            const result = await axios.get('/checkbox/fiscalization-triggers/statuses');
            commit('changeTriggerStatuses', result.data.models);
            return {
                status: true,
                data: result.data.models
            };
        } catch (e) {
            console.log(e);
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    createTrigger: async (ctx, payload) => {
        try {
            const result = await axios.post('/checkbox/fiscalization-triggers', payload);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    updateTrigger: async (ctx, { id, data }) => {
        try {
            const result = await axios.put(`/checkbox/fiscalization-triggers/${id}`, data);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },

    deleteTrigger: async (ctx, id) => {
        try {
            const result = await axios.delete(`/checkbox/fiscalization-triggers/${id}`);
            return {
                status: true,
                data: result.data
            };
        } catch (e) {
            return {
                status: false,
                data: e.response?.data
            };
        }
    },
};

const mutations = {
    changeReceipts(state, data) {
        state.receipts = data;
    },
    changeCashiers(state, data) {
        state.cashiers = data;
    },
    changeCashier(state, data) {
        state.cashier = data;
    },
    changeCashiersForSelect(state, data) {
        state.cashiersForSelect = data;
    },
    changePaymentMappings(state, data) {
        state.paymentMappings = data;
    },
    changeCheckboxPaymentTypes(state, data) {
        state.checkboxPaymentTypes = data;
    },
    changeCrmPaymentMethods(state, data) {
        state.crmPaymentMethods = data;
    },
    changePaymentOptions(state, data) {
        state.paymentOptions = data;
    },
    changeFiscalizationTriggers(state, data) {
        state.fiscalizationTriggers = data;
    },
    changeTriggerStatuses(state, data) {
        state.triggerStatuses = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

